import PubSub from "underpub-js";

var HiddenImage = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-HiddenImage',
	};

	$.extend(true, this.options, options);

};

HiddenImage.prototype.init = function() {

	var self = this;

};

export default HiddenImage;
